// Self instantiating version
import initGlider from "./gridslider.js";

window.addEventListener("DOMContentLoaded", () => {
  initGlider();
});
